"use client"

import { Hotel } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `HotelIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const HotelIcon = component(Icon)({ as: Hotel })
